define('feedback',[
  "globals",
  "models/feedback",
  "collections/feedback",
  "views/feedback/rating",
  "./content"
], function (globals, FeedbackModel, FeedbackList, FeedbackRatingView) {
  "use strict";

  $(function () {
    if (globals.options.ui.feedbackEnabled) {
      new FeedbackRatingView({
        collection: new FeedbackList([], { model: FeedbackModel }),
        el: $("#feedback-controls")
      });
    }
  });
});

